var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("vue-typeahead-bootstrap", {
    ref: "tissueOptionsSelect",
    attrs: {
      placeholder: "Add a tissue...",
      data: _vm.tissueOptions,
      serializer: (r) => _vm.capitalizedFormatter(r),
      showOnFocus: true,
      minMatchingChars: 0,
      maxMatches: 1000,
    },
    on: {
      hit: function ($event) {
        return _vm.onTissueSelect($event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "suggestion",
        fn: function ({ data, htmlText }) {
          return [
            _c("span", { domProps: { innerHTML: _vm._s(htmlText) } }),
            _vm._v("  "),
          ]
        },
      },
    ]),
    model: {
      value: _vm.userText,
      callback: function ($$v) {
        _vm.userText = $$v
      },
      expression: "userText",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }